import React from "react";
import { Form, Input, Button, Select, Space, Row, Col, message } from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import withRouter from "../withRouter";
import { CopyOutlined } from "@ant-design/icons";
import LicenseControlStore from "../store/LicenseControlStore";
import CompanyAutocomplete from "./CompanyAutocomplete";
import CompanyStore from "../store/CompanyStore";

class LicenseControladd extends React.Component {
  formRef = React.createRef();

  constructor(props) {
    super(props);
    this.licenseControlStore = new LicenseControlStore();
    this.companyStore = new CompanyStore(this);

    this.state = {
      companyId: "",
      company_value_label: "",
      vehicleList: [],
      vehicleId: undefined,
      deviceId: "",
      loading: false,
      generating: false,
      licenseNumber: "",
    };
  }

  async componentDidMount() {
    if (this.props.editData?.id) {
      const data = this.props.editData;
      if (data.companyId) {
        await this.loadVehicles(data.companyId);
        const singleData = await this.companyStore.getCompanyDataById(data.companyId);
        this.setState({
          company_value_label: singleData,
          companyId: data.companyId,
          vehicleId: data.vehicleId,
          deviceId: data.deviceId || "",
        });
        this.formRef.current?.setFieldsValue({
          companyId: singleData,
          vehicleId: data.vehicleId,
          deviceId: data.deviceId || "",
        });
      }
    }
  }

  loadVehicles = async (companyId) => {
    const response = await this.licenseControlStore.getAssetList({ companyId });
    this.setState({ vehicleList: response ?? [] });
  };

  handleCompanyChange = async (comp) => {
    if (comp) {
      this.setState({
        companyId: comp.value,
        company_value_label: comp,
        vehicleId: undefined,
        vehicleList: [],
      });
      // Reset vehicle field when company changes
      this.formRef.current?.setFieldsValue({ vehicleId: undefined });
      await this.loadVehicles(comp.value);
    }
  };

  handleGenerate = async () => {
    try {
      await this.formRef.current?.validateFields();
    } catch {
      return;
    }

    this.setState({ generating: true });

    const payload = {
      companyId: this.state.companyId,
      vehicleId: this.state.vehicleId,
      deviceId: this.state.deviceId,
    };
    console.log("1@@@@@@@@@@@@@@",payload);
    const response = await this.licenseControlStore.generateLicense(payload);
    console.log("########",response);
    if (response?.data?.success === "S") {
      this.setState({ 
        licenseNumber: response.data.encryptedData || response.data.data?.encryptedData || "",
        generating: false 
      });
      message.success(response.data.message || "License generated successfully");
      
      console.log("###########",this.licenseControlStore.loadData({companyId: this.state.companyId}))
    } else {
      message.error(response?.data?.message || "Failed to generate license");
      this.setState({ generating: false });
    }
  };

  handleSubmit = async () => {
    if (!this.state.licenseNumber) {
      message.warning("Please generate license first");
      return;
    }

    this.setState({ loading: true });

    const payload = {
      companyId: this.state.companyId,
      vehicleId: this.state.vehicleId,
      deviceId: this.state.deviceId,
      licenseNumber: this.state.licenseNumber,
    };

    const response = await this.licenseControlStore.updateLicense(payload);

    this.setState({
      loading: false,
      companyId: "",
      company_value_label: "",
      vehicleList: [],
      vehicleId: undefined,
      deviceId: "",
      licenseNumber: "",
    });
    this.formRef.current?.resetFields();
    this.props.response(response);
  };

  handleCopyLicense = () => {
    navigator.clipboard.writeText(this.state.licenseNumber);
    message.success("License number copied to clipboard");
  };

  render() {
    const { vehicleList, companyId, vehicleId, deviceId, licenseNumber, generating } = this.state;

    return (
      <div style={{ display: "flex", flexDirection: "column", height: "100%", position: "relative" }}>

        {/* ── Scrollable Body ── */}
        <div style={{ flex: 1, overflowY: "auto", padding: "16px 24px", paddingBottom: "80px" }}>
          <Form layout="vertical" ref={this.formRef}>
            <Row gutter={16}>

              {/* ── LEFT COLUMN: Company + Device ID ── */}
              <Col span={12}>
                {/* Company Search Dropdown */}
                <Form.Item
                  name="companyId"
                  label={
                    <span>
                      {this.context.translate("_ACCOUNT_")}
                      <span style={{ color: "red" }}> *</span>
                    </span>
                  }
                  required={false}
                  rules={[
                    {
                      required: true,
                      message: `${this.context.translate("_ACCOUNT_")} ${this.context.translate("_IS_REQUIRED_")}`,
                    },
                  ]}
                >
                  <CompanyAutocomplete
                    value={this.state.company_value_label || null}
                    onChange={this.handleCompanyChange}
                    style={{ width: "100%" }}
                    fromAccountList={1}
                  />
                </Form.Item>

                {/* Device ID Text Field */}
                <Form.Item
                  name="deviceId"
                  label={
                    <span>
                      {this.context.translate("_DEVICE_ID_") || "Device ID"}
                      <span style={{ color: "red" }}> *</span>
                    </span>
                  }
                  required={false}
                  rules={[
                    {
                      required: true,
                      message: `${this.context.translate("_DEVICE_ID_") || "Device ID"} ${this.context.translate("_IS_REQUIRED_")}`,
                    },
                  ]}
                >
                  <Input
                    placeholder={this.context.translate("_ENTER_DEVICE_ID_")}
                    value={deviceId}
                    onChange={(e) => {
                      this.setState({ deviceId: e.target.value });
                      this.formRef.current?.setFieldsValue({ deviceId: e.target.value });
                    }}
                  />
                </Form.Item>
              </Col>

              {/* ── RIGHT COLUMN: Vehicle Dropdown ── */}
              <Col span={12}>
                <Form.Item
                  name="vehicleId"
                  label={
                    <span>
                      {this.context.translate("_VEHICLE_NO_")}
                      <span style={{ color: "red" }}> *</span>
                    </span>
                  }
                  required={false}
                  rules={[
                    {
                      required: true,
                      message: `${this.context.translate("_VEHICLE_NO_")} ${this.context.translate("_IS_REQUIRED_")}`,
                    },
                  ]}
                >
                  <Select
                    showSearch
                    optionFilterProp="label"
                    placeholder={
                      companyId
                        ? this.context.translate("_VEHICLE_NO_")
                        : this.context.translate("_SELECT_ACCOUNT_FIRST_") || "Select account first"
                    }
                    value={vehicleId || undefined}
                    disabled={!companyId}
                    style={{ width: "100%" }}
                    onChange={(v) => {
                      this.setState({ vehicleId: v });
                      this.formRef.current?.setFieldsValue({ vehicleId: v });
                    }}
                    options={vehicleList.map((v) => ({
                      value: v.vehicleId ?? v.assetId,
                      label: v.vehicleNo ?? v.assetName,
                    }))}
                  />
                </Form.Item>
                 {licenseNumber && (
                    <Form.Item
                        label={
                        <span>
                            {this.context.translate("_ENCRYPTED_LICENSE_NUMBER_") || "License Number"}
                        </span>
                        }
                    >
                        <Input
                        value={licenseNumber}
                        readOnly
                        addonAfter={
                            <CopyOutlined
                            style={{ cursor: "pointer" }}
                            onClick={this.handleCopyLicense}
                            />
                        }
                        />
                    </Form.Item>
                 )}
              </Col>

            </Row>

            {/* License Number Field (shown after generation) */}
            {/* {licenseNumber && (
              <Form.Item
                label={
                  <span>
                    {this.context.translate("_ENCRYPTED_LICENSE_NUMBER_") || "License Number"}
                  </span>
                }
              >
                <Input
                  value={licenseNumber}
                  readOnly
                  addonAfter={
                    <CopyOutlined
                      style={{ cursor: "pointer" }}
                      onClick={this.handleCopyLicense}
                    />
                  }
                />
              </Form.Item>
            )} */}
          </Form>
        </div>

        {/* ── Fixed Bottom Buttons ── */}
        <div
          style={{
            position:       "absolute",
            bottom:         0,
            left:           0,
            right:          0,
            padding:        "12px 24px",
            background:     "#fff",
            borderTop:      "1px solid #f0f0f0",
            display:        "flex",
            justifyContent: "flex-end",
          }}
        >
          <Space>
            <Button
              className="cancelButtonClass"
            onClick={async() => {this.props.closeModal();
            await this.licenseControlStore.loadData({
                offset: 0,
                limit: 50,
                companyId: this.state.companyId,
                assetName: undefined,
                deviceId: undefined
            })
            this.setState({loadData:1})
            }}
            >
              {this.context.translate("_BACK_") || "Back"}
            </Button>
            <Button
              type="primary"
              className="formsSaveButton"
              loading={generating}
              onClick={this.handleGenerate}
            >
              {this.context.translate("_GENERATE_") || "Generate"}
            </Button>
            <Button
              className="cancelButtonClass"
              onClick={() => this.props.closeModal()}
            >
              {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
            </Button>
            
            {/* <Button
              type="primary"
              className="addButtonClass"
              loading={this.state.loading}
              disabled={!licenseNumber}
              onClick={this.handleSubmit}
            >
              {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
            </Button> */}
          </Space>
        </div>

      </div>
    );
  }
}

LicenseControladd.contextType = StoreContext;
export default observer(withRouter(LicenseControladd));